export function sendToExtension(type, payload) {
    const callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type, payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum/~/@datadog/browser-core/esm/tools/sendToExtension.js